import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION24: PdfComponent = {
  type: 'section',
  id: 's24',
  title: '24. Announcements',
  content: [
    {
      type: 'bulletList',
      id: 's24bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Subject to clause 24.2, no announcement or other public disclosure concerning this Agreement or any of the matters contained in it shall be made by, or on behalf of, the Subscriber without the prior written consent of Kanda (such consent not to be unreasonably withheld or delayed).',
        },
        {
          copy: 'If Kanda is required to make an announcement or other public disclosure concerning this Agreement or any of the matters contained in it by law, any court, any governmental or regulatory body (including any recognised investment exchange), or any other authority of competent jurisdiction, it may do so. Kanda shall:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'notify the Subscriber as soon as is reasonably practicable upon becoming aware of such requirement, to the extent permitted by law, court order, or regulatory authority;',
              },
              {
                copy: 'make the relevant announcement or public disclosure after consultation with the Subscriber so far as is reasonably practicable; and',
              },
              {
                copy: 'take into account all reasonable requirements of the Subscriber as to the form, content, and manner of release of the announcement or disclosure, so far as is reasonably practicable.',
              },
            ],
          },
        },
      ],
      prefix: '24',
    },
  ],
};
